import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "subContents",
  class: "intro wrap_1120"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("section", {
      id: "introCon",
      class: "intro-page",
      style: {"display":"flex","justify-content":"center","align-items":"center"}
    }, [
      _createElementVNode("article", { class: "intro-con" }, [
        _createElementVNode("img", {
          src: "img/platform.png",
          style: {"max-width":"100%"}
        })
      ])
    ], -1)
  ]))]))
}